const FundisPage = () => import('./index.vue')
const FundisFilter = () => import('./_pages/fundis_filter.vue')
const FundisStatus = () => import('./_pages/fundis_filter.vue')
const ManualSubscriptionIndex = () => import('./_pages/subscription.vue')
import { EditorGuard, ManagerGuard } from '@/common/guard'

export default [
  {
    path: '/experts',
    beforeEnter: EditorGuard,
    component: FundisPage,
    name: 'FundiIndex'
  },
  {
    path: '/experts/subscriptions',
    beforeEnter: EditorGuard,
    component: FundisFilter,
    name: 'FundisFilter'
  },
  {
    path: '/packages/manual/subscribe/:userId/:id/:option',
    beforeEnter: ManagerGuard,
    component: ManualSubscriptionIndex,
    name: 'ManualSubscriptionIndexRoute'
  }
]
